import Commons from './Commons';

export default class Asserts {

    static type(object,clazzName) {
        if (clazzName.startsWith('?')) {
            if (object==null) {
                return;
            }
            clazzName = clazzName.substring(1);
        }
        if (!(Commons.typeName(object)==clazzName)) {
            console.error('TypeError not instanceof '+clazzName+': ',object);
            throw new Error('TypeError not instanceof '+clazzName);
        }
    }

    static notNull(value,messageIfNull="value may not be null") {
        if (value==null) {
            throw new Error(messageIfNull);
        }
        return value;
    }

}